import { getRenderableAttributes } from '@components/Tags/utils';
import { variantFragment } from '@containers/ProductDetailContainer/queries/__generated__/variantFragment';
import { IStock } from '@containers/ProductListing/model';

const hasTagOrDiscount = (variant: variantFragment): boolean => {
  const attributes = getRenderableAttributes(variant.attributes);
  const hasAttributes = Object.keys(attributes).length > 0;
  const hasDiscount =
    variant.stockAvailability.code !== IStock.outOfStock &&
    Boolean(variant.originalPrice) &&
    variant.originalPrice.value > 0;
  return hasAttributes || hasDiscount;
};

export const shouldRenderTagDiscount = (variants: variantFragment[]): boolean =>
  variants.some(hasTagOrDiscount);
